/**
 * @fileoverview Agent definition for chapter-planner-v2.
 *
 * Plans a chapter for a story based on existing context.
 *
 * @category narrative.chapters.planning
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'chapter-planner-v2',
  kind: 'primitive',
  name: 'Chapter Planner',
  description: 'Plans a chapter for a story based on existing context.',
  category: 'structure',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2024-06',
    lastUpdated: '2026-01',
    taxonomyPath: 'narrative.chapters.planning',
    usedBy: [
      'primitives/use-chapter-planner-v2.ts',
    ],
    usedInComposites: [
      'chapter-planner-composite-v1',
    ],
    relatedAgents: [
      'next-chapter-suggester-v2',
      'chapter-architect-v2',
    ],
  },
};
